import { useCallback } from 'react';
import DOMPurify from 'dompurify';
import { prop } from 'ramda';
import { useGetURLTemplate } from 'server';

import { submitAdvancedDialog } from '@core/js/components/popups/AdvancedPlayerMessage/server';
import { useAppSelector, useGameConfigurationSelector } from '@core/js/store/hooks';

import { getButtons } from '@theme/js/hooks/usePublicAPI/sun/useShowToasterNotification/helpers';
import { useShowNotification } from '@theme/js/hooks/useShowNotification/useShowNotification';

import { IAdvancedDialogData } from './types';

interface ToasterOptions {
    autoHideDuration: number;
    isHideCloseBtn: boolean;
    data: IAdvancedDialogData;
}

const useGetActions = () => {
    const games = useGameConfigurationSelector(prop('games'));
    const cashierUrlTemplates = useAppSelector(prop('cashierUrlTemplates'));
    const showNotification = useShowNotification();

    const getURLTemplate = useGetURLTemplate();

    return useCallback(({ data }: { data: IAdvancedDialogData }) => getButtons({
        data,
        submitAdvancedDialog,
        showNotification,
        games,
        urlTypeList: cashierUrlTemplates,
        getURLs: getURLTemplate
    }),
    [
        showNotification,
        games,
        cashierUrlTemplates,
        getURLTemplate
    ]);
};

export const useShowToasterNotification = () => {
    const showNotification = useShowNotification();
    const getActions = useGetActions();

    return useCallback(
        (
            message: string,
            { autoHideDuration, isHideCloseBtn, data }: ToasterOptions
        ) => {
            console.log('>>> showTosterNotification', data);
            const { onClick, onClose } = getActions({ data });

            showNotification(DOMPurify.sanitize(message, { ADD_ATTR: ['target'] }), {
                autoHideDuration,
                isHideCloseBtn,
                onClick,
                handleClose: onClose
            });
        },
        [getActions, showNotification]
    );
};
